module.exports = __webpack_public_path__ + "img/menu-my-account.2d7cf25b.svg";